import { render, staticRenderFns } from "./PlansTab.vue?vue&type=template&id=40420742&scoped=true&lang=pug"
import script from "./PlansTab.vue?vue&type=script&lang=js"
export * from "./PlansTab.vue?vue&type=script&lang=js"
import style0 from "./PlansTab.vue?vue&type=style&index=0&id=40420742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40420742",
  null
  
)

export default component.exports